<section id="pillars" class="about-pillars dingo-section dingo-bg-base">
  <div class="container">
    <div class="about-section-head section-head reveal-on-scroll" data-reveal="section-head">
      <p class="about-kicker">Nuestra forma de trabajar</p>
      <h2 class="about-section-title">
        Pilares que sostienen <span class="highlight-green">cada proyecto</span>
      </h2>
      <p class="about-section-desc">
        Estos principios guían nuestra cultura, decisiones y relación con cada cliente.
      </p>
    </div>

    <div class="about-pillar-grid">
      @for (pillar of pillars; track pillar.title; let i = $index) {
      <article class="about-pillar-card reveal-on-scroll" data-reveal="card" [style.--reveal-order]="i % 2">
        <div class="about-pillar-icon">
          <i class="bi {{ pillar.icon }}"></i>
        </div>
        <h3>{{ pillar.title }}</h3>
        <p>{{ pillar.description }}</p>
      </article>
      }
    </div>
  </div>
</section>
